import React from 'react';

const Seedance2 = () => (
  <article className="news-article-body">
    <p className="news-lead">
      ByteDance's Seedance 2.0 is, in the opinion of many video professionals who've used
      it, the best AI video generation system available as of mid-2025. It generates
      high-quality video clips from text or image prompts, with better motion consistency
      and longer clip durations than previous generation tools. For a company known for
      TikTok's video algorithm, it makes sense that ByteDance would get AI video generation
      right.
    </p>

    <h2>What makes Seedance different</h2>
    <p>
      AI video generation has a well-known problem: things move weirdly. Hands gain extra
      fingers, hair flows backwards, faces morph unpredictably. Early tools like Sora
      impressed with brief clips but fell apart over longer durations.
    </p>
    <p>
      Seedance 2.0 addresses this with improved temporal consistency - maintaining coherent
      motion and character appearance across frames. Key capabilities:
    </p>
    <ul>
      <li><strong>Duration:</strong> Up to 30-second clips at 720p or 1080p</li>
      <li><strong>Camera control:</strong> Specify camera movement - zoom, pan, dolly, orbit - in the prompt</li>
      <li><strong>Character consistency:</strong> Maintains the same face and body across a sequence</li>
      <li><strong>Style control:</strong> Cinematic, anime, documentary, sketch - controllable aesthetic modes</li>
      <li><strong>Image-to-video:</strong> Animate a still image with specified motion</li>
    </ul>

    <h2>The ByteDance advantage</h2>
    <p>
      ByteDance has been training video models longer than most companies. TikTok's
      recommendation and content moderation systems have processed billions of videos.
      That video data and the video understanding research that supports TikTok translate
      directly into better AI video generation.
    </p>
    <p>
      The team also includes researchers who worked on the original Sora-class video models,
      and ByteDance has invested heavily in the compute infrastructure needed for video
      generation (which is substantially more demanding than text generation).
    </p>

    <h2>How it's being used</h2>
    <p>
      The main use cases emerging in early adoption:
    </p>
    <ul>
      <li>Short-form social content creation - the obvious synergy with TikTok's creator ecosystem</li>
      <li>Advertising and marketing - rapid concept video prototyping</li>
      <li>Film pre-visualisation - blocking out scene compositions before live production</li>
      <li>Education content - animated explanations from written descriptions</li>
    </ul>

    <h2>What it can't do yet</h2>
    <p>
      Seedance 2.0 is impressive but not a professional film production tool. Generating
      consistent characters across multiple separate video segments (rather than one continuous
      clip) is still unreliable. High-motion action sequences and crowd scenes still degrade.
      And at 30 seconds maximum, it's a creative tool, not a feature-film pipeline.
    </p>

    <div className="news-insight-box">
      <h3>The big lesson</h3>
      <p>
        AI video generation has reached the point where short, high-quality clips are practical
        for many commercial applications. ByteDance's Seedance 2.0, alongside competitors
        like Sora, Kling, and Hailuo, is changing what a small team with limited budget can
        produce. The question for creative professionals is no longer "can AI do this?" but
        "how do I integrate this into a real workflow?"
      </p>
    </div>
  </article>
);

export default Seedance2;
